import withMedianTooltip from '../hoc/withMedianTooltip'
import { handleBaseCellValue } from './helper'

const BaseCell = ({ val, locale }) => {
  return <span className={'textEnd'}>{handleBaseCellValue(val, locale)}</span>
}

export default withMedianTooltip(BaseCell)
